var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item",class:{active: _vm.step === index + 1}},[_c('div',[_vm._v(_vm._s(index + 1))]),_c('font',[_vm._v(_vm._s(item))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }